import * as _ from 'lodash';
import DecimalAmount from '../../../../support/DecimalAmount';

class FactorajeFinancieroCalculator {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  static make(data) {
    return new FactorajeFinancieroCalculator(data);
  }

  apply() {
    const data = this.data || {};

    const factorajeFinanciero = {};

    const Aforo = data.Aforo;
    const Moneda = data.Moneda;
    const Honorarios = data.Honorarios;
    const TasaInteres = data.TasaInteres;
    const Equivalencia = data.Equivalencia;
    const MontoContrato = data.MontoContrato;

    factorajeFinanciero.Aforo = Aforo;
    factorajeFinanciero.Moneda = Moneda;
    factorajeFinanciero.Honorarios = Honorarios;
    factorajeFinanciero.TasaInteres = TasaInteres;
    factorajeFinanciero.Equivalencia = Equivalencia;
    factorajeFinanciero.MontoContrato = MontoContrato;
    factorajeFinanciero.MontoAforo = this.getMontoAforo(MontoContrato, Aforo);
    factorajeFinanciero.ImporteAforado = this.getImporteAforado(MontoContrato, Aforo);
    factorajeFinanciero.ImportePagoInicial = this.getImportePagoInicial(MontoContrato, Aforo, Honorarios);
    factorajeFinanciero.CompensacionHonorarios = this.getCompensacionHonorarios(MontoContrato, Honorarios);
    factorajeFinanciero.CompensacionIntereses = this.getCompensacionIntereses(MontoContrato, Aforo, TasaInteres);

    factorajeFinanciero.ImportePagoFinal = DecimalAmount.make(
      MontoContrato -
        factorajeFinanciero.ImportePagoInicial -
        factorajeFinanciero.CompensacionHonorarios -
        factorajeFinanciero.CompensacionIntereses
    ).toFixed(2);

    return {
      ...factorajeFinanciero,
    };
  }

  getMontoAforo(MontoContrato, Aforo) {
    const MontoAforo = parseFloat(MontoContrato) * parseFloat(Aforo / 100);

    return DecimalAmount.make(MontoAforo).toFixed(2);
  }

  getImporteAforado(MontoContrato, Aforo) {
    const ImporteAforado = parseFloat(MontoContrato) - this.getMontoAforo(MontoContrato, Aforo);

    return DecimalAmount.make(ImporteAforado).toFixed(2);
  }

  getCompensacionHonorarios(MontoContrato, Honorarios) {
    const CompensacionHonorarios = parseFloat(MontoContrato) * parseFloat(Honorarios / 100);

    return DecimalAmount.make(CompensacionHonorarios).toFixed(2);
  }

  getImportePagoInicial(MontoContrato, Aforo, Honorarios) {
    const total =
      parseFloat(MontoContrato) -
      this.getMontoAforo(MontoContrato, Aforo) -
      this.getCompensacionHonorarios(MontoContrato, Honorarios);

    return DecimalAmount.make(total).toFixed(2);
  }

  getCompensacionIntereses(MontoContrato, Aforo, TasaInteres) {
    let CompensacionIntereses = this.getImporteAforado(MontoContrato, Aforo) * parseFloat(TasaInteres / 100);

    return DecimalAmount.make(CompensacionIntereses).toFixed(2);
  }
}

export default FactorajeFinancieroCalculator;
